<template>
  <a-layout class="dd-layout">
    <a-layout-header v-show="true">
      <Header parent="home"></Header>
    </a-layout-header>
    <a-layout>
      <a-layout-content v-show="swipeMapVisible==1">
        <div
          id="mapDiv"
          class="dd-map"
        >
          <div
            class="dd-sider-trigger"
            :style="'width:'+(siderCollapse?'300px':'76px')"
            v-show="false"
          >
            <img src="../assets/layer.png" />
            <div
              v-show="siderCollapse"
              class="dd-arrow"
              @click="siderCollapse = !siderCollapse"
            >
              <div></div>
              <div></div>
            </div>
            <div
              v-show="!siderCollapse"
              class="dd-open-arrow"
              @click="siderCollapse = !siderCollapse"
            >
            </div>
          </div>
          <div
            class="dd-slider"
            v-show="siderCollapse"
          >
            <a-collapse
              v-model="activeKey"
              class="dd-collapse"
              :expand-icon-position="'right'"
              :accordion="true"
            >
              <a-collapse-panel
                key="1"
                header="业务图层"
              >
                <a-tree
                  checkable
                  :tree-data="treeData"
                  v-model="layerTreeCheckedKeys"
                  @check="treeNodeCheck"
                  draggable
                  @drop="layerOrderChange"
                >
                  <template
                    slot="layer-title"
                    slot-scope="record"
                  >
                    <a-dropdown
                      :trigger="['contextmenu']"
                      overlayClassName="dd-right-menu-overlay"
                    >
                      <div>
                        <!-- <a-icon
                          type="setting"
                          title="设置样式"
                          @click="setStyle(record)"
                        />
                        &nbsp;&nbsp; -->
                        {{record.title}}
                      </div>
                      <a-menu slot="overlay">
                        <a-menu-item
                          key="1"
                          @click="setStyle(record)"
                        >
                          设置样式
                        </a-menu-item>
                        <a-menu-item
                          key="2"
                          @click="openAttrTable(record)"
                        >
                          查看属性表
                        </a-menu-item>
                        <a-menu-item
                          key="3"
                          @click="zoomToLayer(record)"
                        >
                          缩放至该图层
                        </a-menu-item>
                        <a-menu-item
                          key="4"
                          @click="downloadVector(record)"
                        >
                          导出SHP
                        </a-menu-item>
                      </a-menu>
                    </a-dropdown>

                  </template>
                </a-tree>
              </a-collapse-panel>
              <a-collapse-panel
                key="2"
                header="分析结果"
                :disabled="false"
              >
                <a-tree
                  checkable
                  :tree-data="treeAnalysisData"
                  @check="treeAnalysisNodeCheck"
                >
                  <template
                    slot="analysis-title"
                    slot-scope="{title,key}"
                  >
                    <a-icon
                      type="download"
                      @click="exportAnalysis(key)"
                    />
                    <a-popconfirm
                      title="确认要删除吗?"
                      cancelText="取消"
                      placement="topRight"
                      okText="确认"
                      @confirm="() => deleteAnalysis(key)"
                    >
                      <a-icon
                        type="delete"
                        title="删除"
                      />
                    </a-popconfirm>
                    &nbsp;&nbsp;{{title}}
                  </template>
                </a-tree>
              </a-collapse-panel>
              <a-collapse-panel
                key="3"
                header="标绘层"
              >
                <a-tree
                  checkable
                  :tree-data="treeGraphicData"
                  v-model="treeGraphicSelectedKeys"
                  @check="treeGraphicCheck"
                >
                  <template
                    slot="dategroup-title"
                    slot-scope="{title,key}"
                  >
                    <a-icon
                      type="download"
                      @click="exportGraph(key)"
                    />
                    &nbsp;&nbsp;{{title}}
                  </template>
                  <template
                    slot="graphic-title"
                    slot-scope="{title,key}"
                  >
                    <a-popconfirm
                      title="确认要删除吗?"
                      cancelText="取消"
                      placement="topRight"
                      okText="确认"
                      @confirm="() => deleteGraphic(key)"
                    >
                      <a-icon
                        type="delete"
                        title="删除"
                      />
                    </a-popconfirm>
                    &nbsp;&nbsp;{{title}}
                  </template>
                </a-tree>
              </a-collapse-panel>
              <a-collapse-panel
                key="4"
                header="底图"
                v-show="false"
              >
                <a-tree
                  checkable
                  :tree-data="treeBaseMapData"
                  v-model="treeBaseMapSelectedKey"
                  @check="treeBaseMapCheck"
                  :multiple="false"
                >
                </a-tree>
              </a-collapse-panel>
              <a-collapse-panel
                key="5"
                header="基础图层"
                v-show="false"
              >
                <a-tree
                  checkable
                  :tree-data="treeBaseLayerData"
                  v-model="baseLayerTreeCheckedKeys"
                  @check="treeBaseNodeCheck"
                />
              </a-collapse-panel>
            </a-collapse>

            <div
              class="dd-legend-panel"
              v-show="legendLayer.length>0"
            >
              <span>图例</span>
              <div>
                <div
                  v-for="legend in legendLayer"
                  :key="legend.key"
                >
                  <span>{{legend.title}}</span>
                  <img :src="legend.src">
                </div>
              </div>
            </div>

          </div>
          <div
            class="dd-attr-table"
            :style="'left:'+(siderCollapse?'100px':'100px')+';height:'+(!attrTableCollapse?'auto':'35px')"
            v-show="isShowAttrTable"
          >
            <div class="dd-attr-title">
              <a-icon
                type="info-circle"
                style="color:#fff"
                theme="filled"
              /> 记录数：{{attrTotal}}
              <a-icon
                type="close"
                title="关闭"
                style="float:right;margin-top:2px;font-size:16px; cursor:pointer;"
                @click="isShowAttrTable=false"
              />
              <a-icon
                style="float:right;margin-top:2px;font-size:16px; cursor:pointer;margin-right:10px;"
                :type="!attrTableCollapse?'down':'up'"
                :title="!attrTableCollapse?'隐藏':'显示'"
                @click="attrTableCollapse=!attrTableCollapse"
              />
              <a-icon
                style="float:right;margin-top:2px;font-size:16px; cursor:pointer;margin-right:15px;"
                type="pie-chart"
                title="数据/图表切换"
                v-show="false"
                @click="showAttrChart"
              />
              <download-excel
                :data="jsonData"
                :fields="jsonFields"
                style="float:right;font-size:16px; cursor:pointer;margin-right:20px;height:16px;"
                title="导出Excel"
                name="导出Excel"
              >
                <a-icon type="download"></a-icon>
              </download-excel>
              <a-icon
                v-show="!attrPieChartVisible"
                type="caret-left"
                class="dd-field-left"
                @click="fieldMove('left')"
              />
              <a-icon
                v-show="!attrPieChartVisible"
                type="caret-right"
                class="dd-field-right"
                @click="fieldMove('right')"
              />
            </div>
            <div
              v-show="attrPieChartVisible"
              style="height:238px;padding:4px;width:100%;position:relative;"
            >
              <a-select
                style="width:200px;position:absolute;top:10px;left:calc(50% - 100px);z-index:1000;"
                placeholder="请选择字段"
                v-model="selectedChartField"
                @change="chartFieldChange"
              >
                <a-select-option
                  v-for="col in attrColumns"
                  :key="col.dataIndex"
                >{{col.title}}
                </a-select-option>
              </a-select>
              <div
                class="dd-chart-container"
                id="pieChartDiv"
              ></div>
            </div>
            <div
              v-show="!attrPieChartVisible"
              style="padding-bottom:38px;"
            >
              <a-table
                id="refAttrTable"
                :columns="attrColumns"
                :data-source="attrData"
                :pagination="false"
                :custom-row="rowClick"
                :scroll="{ y: 175,x: attrColumns.length*120 }"
              >
                <img
                  src="../assets/pic_link.png"
                  slot="picLink"
                  slot-scope="text"
                  @click.stop="showPicList(text)"
                >
                <!-- <a
                  slot="picLink"
                  slot-scope="text"
                  @click.stop="showPicList(text)"
                >{{text}}</a> -->
              </a-table>
              <div
                class="dd-table-footer"
                v-show="!attrTableCollapse"
              >
                <a-radio-group
                  v-model="attrTableSelectedLabel"
                  @change="attrTabLabelChange"
                >
                  <a-radio-button
                    v-for="(item,index) in Object.keys(searchResultLayers)"
                    :key="index"
                    :value="item"
                  >
                    {{getAttrTabLabel(item)}}
                  </a-radio-button>
                </a-radio-group>
              </div>
            </div>
          </div>
          <div
            :style="'position:absolute; top:10px;z-index:1010; right:10px;text-align:right;'"
            v-show="locationXy.visible"
            compact
          >
            <a-input
              style="width: 40%"
              addon-before="X"
              default-value=""
              placeholder="横坐标"
              v-model="locationXy.x"
            />
            <a-input
              style="width: 40%"
              addon-before="Y"
              default-value=""
              placeholder="纵坐标"
              v-model="locationXy.y"
            >
              <a-icon
                slot="addonAfter"
                type="pushpin"
                style="cursor:pointer;"
                @click="locXy"
              />
            </a-input>
            <a-button
              icon="close"
              style="margin-left:5px;"
              @click="closeXy"
            ></a-button>
          </div>
          <a-row class="dd-right-toolbar">
            <a-col :span="24">
              <a-dropdown
                placement="bottomLeft"
                overlayClassName="dd-search-overlay"
              >
                <img
                  src="./../assets/search_unselected.png"
                  title="查询"
                  @mouseover="$event.currentTarget.src=require('../assets/search_selected.png')"
                  @mouseout="$event.currentTarget.src=require('../assets/search_unselected.png')"
                />
                <a-menu slot="overlay">
                  <a-menu-item @click="menuClick('search_rect')">框选查询</a-menu-item>
                  <a-menu-item @click="menuClick('search_polygon')">多边形查询</a-menu-item>
                  <a-menu-item @click="menuClick('search_circle')">圆形查询</a-menu-item>
                  <a-menu-item @click="menuClick('search_point')">点识别</a-menu-item>
                  <a-menu-item @click="menuClick('search_attr')">按属性查询</a-menu-item>
                </a-menu>
              </a-dropdown>
            </a-col>
            <a-col :span="24">
              <a-dropdown
                placement="bottomLeft"
                overlayClassName="dd-analysis-overlay"
              >
                <img
                  src="./../assets/analysis_unselected.png"
                  title="分析"
                  @mouseover="$event.currentTarget.src=require('../assets/analysis_selected.png')"
                  @mouseout="$event.currentTarget.src=require('../assets/analysis_unselected.png')"
                />
                <a-menu slot="overlay">
                  <a-menu-item @click="menuClick('buffer_ana')">缓冲分析</a-menu-item>
                  <a-menu-item @click="menuClick('intersect_ana')">叠加分析</a-menu-item>
                  <!-- <a-menu-item @click="menuClick('buffer_ana')">合并分析</a-menu-item> -->
                  <a-menu-item @click="menuClick('union_ana')">联合分析</a-menu-item>
                  <a-menu-item @click="menuClick('multi_window_ana_2')">多窗口对比/2窗口</a-menu-item>
                  <a-menu-item @click="menuClick('multi_window_ana_4')">多窗口对比/4窗口</a-menu-item>
                  <!-- <a-menu-item @click="menuClick('compare_ana')">多时相分析</a-menu-item> -->
                </a-menu>
              </a-dropdown>

            </a-col>
            <a-col :span="24">
              <a-dropdown
                placement="bottomLeft"
                overlayClassName="dd-tools-overlay"
              >
                <img
                  src="./../assets/tools_unselected.png"
                  title="工具"
                  @mouseover="$event.currentTarget.src=require('../assets/tools_selected.png')"
                  @mouseout="$event.currentTarget.src=require('../assets/tools_unselected.png')"
                />
                <a-menu slot="overlay">
                  <a-menu-item @click="toolClick('length')">测距</a-menu-item>
                  <a-menu-item @click="toolClick('area')">测面积</a-menu-item>
                  <a-menu-item @click="toolClick('point')">标绘点</a-menu-item>
                  <a-menu-item @click="toolClick('line')">标绘线</a-menu-item>
                  <a-menu-item @click="toolClick('polygon')">标绘面</a-menu-item>
                  <a-menu-item @click="toolClick('location')">坐标定位</a-menu-item>
                </a-menu>
              </a-dropdown>

            </a-col>
            <a-col :span="24">
              <img
                src="./../assets/zoom_out_unselected.png"
                @click="toolBoxClick('zoom_out')"
                title="放大"
                @mouseover="$event.currentTarget.src=require('../assets/zoom_out_selected.png')"
                @mouseout="$event.currentTarget.src=require('../assets/zoom_out_unselected.png')"
              />
            </a-col>
            <a-col :span="24">
              <img
                src="../assets/zoom_in_unselected.png"
                @click="toolBoxClick('zoom_in')"
                title="缩小"
                @mouseover="$event.currentTarget.src=require('../assets/zoom_in_selected.png')"
                @mouseout="$event.currentTarget.src=require('../assets/zoom_in_unselected.png')"
              />
            </a-col>
            <a-col :span="24">
              <img
                src="../assets/pan_unselected.png"
                @click="toolBoxClick('pan')"
                title="停止其他操纵"
                @mouseover="$event.currentTarget.src=require('../assets/pan_selected.png')"
                @mouseout="$event.currentTarget.src=require('../assets/pan_unselected.png')"
              />
            </a-col>
            <a-col :span="24">
              <img
                src="../assets/full_unselected.png"
                @click="toolBoxClick('full')"
                title="全图"
                @mouseover="$event.currentTarget.src=require('../assets/full_selected.png')"
                @mouseout="$event.currentTarget.src=require('../assets/full_unselected.png')"
              />
            </a-col>
            <a-col :span="24">
              <img
                src="../assets/left_unselected.png"
                @click="toolBoxClick('left')"
                title="前一视图"
                @mouseover="$event.currentTarget.src=require('../assets/left_selected.png')"
                @mouseout="$event.currentTarget.src=require('../assets/left_unselected.png')"
              />
            </a-col>
            <a-col :span="24">
              <img
                src="../assets/right_unselected.png"
                @click="toolBoxClick('right')"
                title="后一视图"
                @mouseover="$event.currentTarget.src=require('../assets/right_selected.png')"
                @mouseout="$event.currentTarget.src=require('../assets/right_unselected.png')"
              />
            </a-col>
            <a-col :span="24">
              <img
                src="../assets/clean_unselected.png"
                @click="cleanMap"
                title="清屏"
                @mouseover="$event.currentTarget.src=require('../assets/clean_selected.png')"
                @mouseout="$event.currentTarget.src=require('../assets/clean_unselected.png')"
              />
            </a-col>
            <a-col :span="24">
              <img
                src="../assets/save_unselected.png"
                @click="saveMapState"
                title="保存当前状态"
                @mouseover="$event.currentTarget.src=require('../assets/save_selected.png')"
                @mouseout="$event.currentTarget.src=require('../assets/save_unselected.png')"
              />
            </a-col>
            <a-col :span="24">
              <img
                src="../assets/cropimg_unselected.png"
                @click="printMap"
                title="截图"
                @mouseover="$event.currentTarget.src=require('../assets/cropimg_selected.png')"
                @mouseout="$event.currentTarget.src=require('../assets/cropimg_unselected.png')"
              />
            </a-col>
          </a-row>
        </div>
        <a-modal
          v-model="attrModalVisible"
          :width="750"
          title="按属性查询"
          @ok="searchByAttr"
          :maskClosable="false"
          cancelText="取消"
          okText="确定"
          :zIndex="1010"
        >
          <a-row
            type="flex"
            align="middle"
          >
            <a-col
              :span="4"
              style="text-align:right;"
            ><span class="dd-must-has">选择图层：</span> </a-col>
            <a-col :span="5">
              <a-select
                style="width:100%;"
                :options="attrCanSearchLayerList"
                v-model="attrSelectedSearchLayer"
                placeholder="请选择图层"
                @change="layerSelectedChange"
              >
              </a-select>
            </a-col>
            <a-col
              :span="7"
              :offset="1"
            >
              <a-button
                type="primary"
                @click="addCondition"
              >添加条件</a-button>
            </a-col>
          </a-row>

          <a-row
            v-for="(filter,index) in attrFilters"
            :key="index"
            type="flex"
            align="middle"
          >
            <a-col
              :span="2"
              v-show="index>0"
            >
              <a-select
                style="width:100%;"
                v-model="filter.ano"
              >
                <a-select-option value="and">
                  与
                </a-select-option>
                <a-select-option value="or">
                  或
                </a-select-option>
              </a-select>
            </a-col>
            <a-col
              :span="2"
              :offset="index>0?0:2"
              style="text-align:right;"
            >字段：</a-col>
            <a-col :span="5">
              <a-select
                style="width:100%;"
                :options="attrFields"
                v-model="filter.field"
                placeholder="请选择字段"
                @change="fieldChange"
              >
              </a-select>
            </a-col>
            <a-col
              :span="2"
              style="text-align:right;"
            >条件：</a-col>
            <a-col :span="5">
              <a-select
                style="width:100%;"
                :options="attrConditions"
                v-model="filter.condition"
                placeholder="请选择运算符"
              >
              </a-select>
            </a-col>
            <a-col
              :span="2"
              style="text-align:right;"
            >值：</a-col>
            <a-col :span="5">

              <a-auto-complete
                v-model="filter.value"
                :data-source="oneFieldValues"
                placeholder="输入值"
              />
              <!-- <a-input
                              @select="onSelect"
                @search="onSearch"
                @change="onChange"

                type="text"
                autocomplete="off"
                v-model="filter.value"
                placeholder="输入值"
              >
              </a-input> -->
            </a-col>
            <a-col
              :span="1"
              style="text-align:right;"
            >
              <a-icon
                type="close"
                style=" cursor: pointer;"
                @click="attrFilters.pop()"
              ></a-icon>
            </a-col>
          </a-row>
        </a-modal>
        <a-modal
          v-model="bufferModalVisible"
          title="缓冲区分析"
          @ok="executeBufferHandle"
          :maskClosable="false"
          cancelText="取消"
          okText="确定"
          :zIndex="1010"
        >
          <a-row
            type="flex"
            align="middle"
          >
            <a-col
              :span="6"
              style="text-align:right;"
            ><span class="dd-must-has">缓冲图层：</span> </a-col>
            <a-col :span="12">
              <a-select
                style="width:100%;"
                :options="attrCanSearchLayerList"
                v-model="bufferParams.inputs[0]"
                placeholder="请选择图层"
              >
              </a-select>
            </a-col>
          </a-row>
          <a-row
            type="flex"
            align="middle"
          >
            <a-col
              :span="6"
              style="text-align:right;"
            ><span class="dd-must-has">设置缓冲半径：</span> </a-col>
            <a-col :span="12">
              <a-input
                v-model="bufferParams.inputs[1]"
                type="number"
                autocomplete="off"
                placeholer="输入缓冲半径"
              >
              </a-input>
            </a-col>
            <a-col
              :span="1"
              :offset="1"
            >米</a-col>
          </a-row>
          <a-row
            type="flex"
            align="middle"
          >
            <a-col
              :span="6"
              style="text-align:right;"
            ><span>是否保存结果：</span> </a-col>
            <a-col :span="18">
              <a-switch v-model="bufferParams.save" />
            </a-col>
          </a-row>
          <a-row
            type="flex"
            align="middle"
            v-show="bufferParams.save"
          >
            <a-col
              :span="6"
              style="text-align:right;"
            ><span>结果名称：</span> </a-col>
            <a-col :span="18">
              <a-input
                type="text"
                v-model="bufferParams.name"
              />
            </a-col>
          </a-row>
        </a-modal>
        <a-modal
          v-model="intersectModalVisible"
          :title="intersectModalTitle"
          @ok="executeIntersectHandle"
          :maskClosable="false"
          cancelText="取消"
          okText="确定"
          :zIndex="1010"
        >
          <a-row
            type="flex"
            align="middle"
          >
            <a-col
              :span="6"
              style="text-align:right;"
            ><span class="dd-must-has">第一个图层：</span> </a-col>
            <a-col :span="12">
              <a-select
                style="width:100%;"
                :options="attrCanSearchLayerList"
                v-model="intersectParams.inputs[0]"
                placeholder="请选择图层"
              >
              </a-select>
            </a-col>
          </a-row>
          <a-row
            type="flex"
            align="middle"
          >
            <a-col
              :span="6"
              style="text-align:right;"
            ><span class="dd-must-has">第二个图层：</span> </a-col>
            <a-col :span="12">
              <a-select
                style="width:100%;"
                :options="attrCanSearchLayerList"
                v-model="intersectParams.inputs[1]"
                placeholder="请选择图层"
              >
              </a-select>
            </a-col>
          </a-row>
          <a-row
            type="flex"
            align="middle"
          >
            <a-col
              :span="6"
              style="text-align:right;"
            ><span>是否保存结果：</span> </a-col>
            <a-col :span="18">
              <a-switch v-model="intersectParams.save" />
            </a-col>
          </a-row>
          <a-row
            type="flex"
            align="middle"
            v-show="intersectParams.save"
          >
            <a-col
              :span="6"
              style="text-align:right;"
            ><span>结果名称：</span> </a-col>
            <a-col :span="18">
              <a-input
                type="text"
                v-model="intersectParams.name"
              />
            </a-col>
          </a-row>
        </a-modal>
        <style-setting
          ref="styleSettingC"
          @okClose="styleModalOkClose"
        ></style-setting>
        <div class="dd-ext-popup-content">
          <div
            style="width:300px;"
            id="extPopupContent"
          >
            <a-row
              type="flex"
              align="middle"
            >
              <a-col
                :span="24"
                style="font-weight:bold; text-align:left;font-size:14px;"
              >编辑属性</a-col>
            </a-row>
            <a-row
              type="flex"
              align="middle"
            >
              <a-col :span="6">{{graphicAttr.label+"："}}</a-col>
              <a-col :span="18">{{graphicAttr.value}}</a-col>
            </a-row>
            <a-row
              type="flex"
              align="middle"
            >
              <a-col :span="6">所属类别：</a-col>
              <a-col :span="18">
                <a-input
                  size="small"
                  v-model="graphicAttr.p_group"
                  placeholder="请输入所属类别"
                />
              </a-col>
            </a-row>
            <a-row
              type="flex"
              align="middle"
            >
              <a-col :span="6">备注：</a-col>
              <a-col :span="18">
                <a-input
                  size="small"
                  v-model="graphicAttr.memo"
                  placeholder="请输入备注信息"
                />
              </a-col>
            </a-row>
            <a-row
              type="flex"
              align="middle"
            >
              <a-col
                :span="24"
                style="text-align:right;"
              >
                <a-button
                  type="primary"
                  size="small"
                  @click="saveGraphic"
                >保存</a-button>
              </a-col>
            </a-row>
          </div>
        </div>
        <div
          v-viewer
          class="dd-viewer-images"
        >
          <template v-for="source in dkImages">
            <img
              :src="source"
              :key="source"
            >
          </template>
        </div>
      </a-layout-content>
      <a-layout-content v-show="swipeMapVisible==2">
        <Swipe
          ref="swipeChild"
          @exitCurrent="swipeMapVisible=1"
        ></Swipe>
      </a-layout-content>
      <a-layout-content v-show="swipeMapVisible==3">
        <MultiWindow
          ref="multiWindowChild"
          @exitCurrent="swipeMapVisible=1"
        ></MultiWindow>
      </a-layout-content>
    </a-layout>
  </a-layout>

</template>

<script>
// @ is an alias to /src
import "ol/ol.css";
import "ol-ext/dist/ol-ext.css";
import { Map, View } from "ol";
import TileWMS from 'ol/source/TileWMS';
import Projection from 'ol/proj/Projection';
import { register } from 'ol/proj/proj4';
import * as olControl from 'ol/control';
import TileLayer from 'ol/layer/Tile';
import ImageLayer from 'ol/layer/Image';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Static from 'ol/source/ImageStatic';
import { Style, Fill, Stroke, Circle, Icon } from 'ol/style';
import Polygon from 'ol/geom/Polygon';
import Point from 'ol/geom/Point';
import { fromCircle } from 'ol/geom/Polygon';
import proj4 from 'proj4';
import Header from '@/components/Header';
import Draw from 'ol/interaction/Draw';
import WKT from 'ol/format/WKT';
import { WFS, GeoJSON } from 'ol/format';
import Intersects from 'ol/format/filter/Intersects';
import Overlay from 'ol/Overlay';
import UndoRedo from 'ol-ext/interaction/UndoRedo';
import ExtPopup from 'ol-ext/overlay/Popup';
import { easeOut } from 'ol/easing';
import { equals } from 'ol/extent';
import { and as andFilter, equalTo as equalToFilter, like as likeFilter, greaterThan as greaterThanFilter, greaterThanOrEqualTo, not as notFilter, or as orFilter, notEqualTo, lessThan as lessThanFilter, lessThanOrEqualTo } from 'ol/format/filter';
import Measure from '../utils/measure';
import format from 'date-fns/format';
import Swipe from '@/components/Swipe';
import MultiWindow from '@/components/MultiWindow';
import * as echarts from 'echarts';
import { getAuthObject, reportStatus } from '../utils/Func';
import dbTool from '../utils/localDb';
import StyleSetting from '../components/StyleSetting.vue';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import TileGrid from 'ol/tilegrid/TileGrid';
import WMTS from 'ol/source/WMTS';
import XYZ from 'ol/source/XYZ';
import epsg9900 from '../utils/epsgParams';
import Print from 'ol-ext/control/Print';
import { saveAs } from 'file-saver';
import { getCenter } from 'ol/extent';

export default {
  name: 'Home',
  data() {
    return {
      printControl: {},
      swipeMapVisible: 1,
      attrModalVisible: false,
      bufferModalVisible: false,
      intersectModalVisible: false,
      intersectModalTitle: "叠加分析",
      siderCollapse: true,
      activeKey: ['1'],
      treeData: [],
      treeBaseLayerData: [],
      baseLayerTreeCheckedKeys: [],
      layerTreeCheckedKeys: [],
      treeAnalysisData: [],
      treeGraphicData: [],
      treeGraphicSelectedKeys: [],
      treeBaseMapData: [
        {
          key: 0,
          title: "北京市影像",
          url: "./img/basemap.png"
        }
      ],
      treeBaseMapSelectedKey: [0],
      map: {},
      mapView: {},
      initExtent: epsg9900.initExtent,
      lastExtent: [],
      undoInteraction: {},
      measureLayer: {},
      layerMap: {},
      paintSource: {},
      paintVector: {},
      paintDraw: {},
      searchResultSource: new VectorSource(),
      lastSelectedFeature: null,
      attrData: [],
      attrColumns: [],
      attrTotal: 0,
      jsonFields: {},
      jsonData: [],
      attrTableCollapse: false,
      attrPieChartVisible: false,
      isShowAttrTable: false,
      searchResultLayers: {},
      attrCanSearchLayerList: [],
      oneFieldValues: [],
      featuresData: [],
      attrConditions: [{
        label: "等于",
        value: "equalTo"
      }, {
        label: "不等于",
        value: "notEqualTo"
      }, {
        label: "大于",
        value: "greaterThan"
      }, {
        label: "大于或等于",
        value: "greaterThanOrEqualTo"
      }, {
        label: "小于",
        value: "lessThan"
      }, {
        label: "小于或等于",
        value: "lessThanOrEqualTo"
      }, {
        label: "包含",
        value: "like"
      }],
      attrFields: [],
      attrSelectedSearchLayer: undefined,
      attrFilters: [],
      attrTableSelectedLabel: "",
      bufferParams: {
        save: false,
        inputs: [undefined, 100],
        method: "BufferFeatureCollection",
        name: "缓冲"
      },
      intersectParams: {
        save: false,
        inputs: [undefined, undefined],
        method: "IntersectionFeatureCollection",
        name: "叠加"
      },
      analysisResultLayers: [],
      analysisResultLayerFromServer: [],
      graphicLayerFromServer: {},
      graphicLayer: {},
      graphicAttr: {
        memo: "",
        geom: "",
        label: "",
        value: "",
        id: undefined,
        p_group: format(new Date(), "yyyy-MM-dd")
      },
      locationXy: {
        visible: false,
        x: 521283.92248535156,
        y: 279873.3759765625
      },
      scope: '<dogscope/>',
      authCode: this.$store.state.authCode,
      dkImages: [],
      legendLayer: [],
      selectedChartField: undefined
    }
  },
  components: {
    Header,
    Swipe,
    StyleSetting,
    MultiWindow,
  },
  watch: {
    layerTreeCheckedKeys: {
      handler(newVal, oldVal) {
        this.legendLayer = [];
        let tempLegendLayer = [];
        for (let index = this.treeData.length - 1, len = this.treeData.length; index > -1; index--) {
          const node = this.treeData[index];
          if (node.type == "分组") {
            const children = node.children;
            children.forEach(child => {
              if (newVal.indexOf(child.key) > -1) {
                tempLegendLayer.push({ title: child.title, layer: child.layer, key: child.key });
              }
            })
          } else if (newVal.indexOf(node.key) > -1) {
            tempLegendLayer.push({ title: node.title, layer: node.layer, key: node.key });
          }
        }
        this.legendLayer = tempLegendLayer.map(l => {
          return { title: l.title, key: l.key, src: `${process.env.VUE_APP_GEOSERVER_ROOT}wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=40&LAYER=chs:${l.layer}&legend_options=bgColor:0x152045;fontColor:0xFFFFFF;fontName:微软雅黑;hideEmptyRules:true` };
        });
      }
    },
    selectedChartField: {
      handler(newVal, oldVal) {
        if (!newVal) {
          this.initAttrPieChart2([], []);
        }
      }
    }
  },
  methods: {
    chartFieldChange(val) {
      let cntObj = {};
      let areaObj = {};
      this.attrData.forEach(d => {
        const feature = d["feature"];
        if (!feature.get(val)) {
          return false;
        }
        if (!cntObj[feature.get(val)]) {
          cntObj[feature.get(val)] = 0;
        }
        cntObj[feature.get(val)]++;
        if (!areaObj[feature.get(val)]) {
          areaObj[feature.get(val)] = 0;
        }
        areaObj[feature.get(val)] += feature.getGeometry().getArea() || 0;
      })
      const cntChartData = Object.keys(cntObj).map(k => {
        return { name: k, value: cntObj[k] };
      })
      const areaChartData = Object.keys(areaObj).map(k => {
        return { name: k, value: Number(areaObj[k]).toFixed(2) || 0 };
      })
      this.initAttrPieChart2(cntChartData, areaChartData);
    },
    fieldChange(val) {
      let tempVals = new Set();
      this.featuresData.forEach(feature => {
        tempVals.add(feature.get(val) + "");
      })
      this.oneFieldValues = Array.from(tempVals).sort();
    },
    fieldMove(direction) {
      if (direction == "left") {
        document.getElementById("refAttrTable").querySelector(".ant-table-body").scrollLeft -= 240;
      } else {
        document.getElementById("refAttrTable").querySelector(".ant-table-body").scrollLeft += 240;
      }
      // console.log(document.getElementById("refAttrTable").querySelector(".ant-table-fixed").style.width);
    },
    downloadVector(record) {
      window.open(`${process.env.VUE_APP_DOWNLOAD_ROOT}${record.layer}.zip`);
    },
    openAttrTable(record) {
      const featureRequest = new WFS().writeGetFeature({
        srsName: "EPSG:990000",
        featureNS: "zhc",
        featurePrefix: "zhc",
        featureTypes: [record.layer],
        outputFormat: "application/json"
      });
      this.searchResultLayers = {};
      this.attrModalVisible = false;
      this.$httpPost(process.env.VUE_APP_GEOSERVER_ROOT + "wfs", new XMLSerializer().serializeToString(featureRequest), { "Content-Type": "text/plain;charset=UTF-8" }).then(res => {
        const features = new GeoJSON().readFeatures(res.data)
        this.attrTotal = features.length;
        features.forEach(feature => {
          const id = feature.getId()
          const layerName = id.split(".")[0]
          if (!this.searchResultLayers[layerName]) {
            this.searchResultLayers[layerName] = []
          }
          this.searchResultLayers[layerName].push(feature);
        })
        const firstLayer = Object.keys(this.searchResultLayers)[0];
        this.showAttrTable(firstLayer);
      })
    },
    zoomToLayer(record) {
      this.map.getView().fit(this.layerMap[record.layer]["bbox"], this.map.getSize())
    },
    styleModalOkClose(layer) {
      console.log(layer);
      const tmpLayer = this.layerMap[layer].layer;
      if (tmpLayer) {
        // tmpLayer.getSource().refresh();
        const source = tmpLayer.getSource();
        const params = source.getParams();
        params.t = new Date().getMilliseconds();
        source.updateParams(params);
      }
    },
    setStyle(record) {
      this.$refs.styleSettingC.$emit("showThis", record);
    },
    printMap() {
      this.printControl.print({ imageType: 'image/png', quality: 0.5 });
    },
    showAttrChart() {
      this.attrPieChartVisible = !this.attrPieChartVisible;
      if (this.attrPieChartVisible) {
        // this.$store.state.loading = true;
        // setTimeout(() => {
        //   this.initAttrPieChart();
        //   this.$store.state.loading = false;
        // }, 500);
      }
    },
    initAttrPieChart2(cntData, areaData) {
      let myChart = echarts.init(document.getElementById('pieChartDiv'));
      let option = {
        title: [{
          text: '地块数量分布',
          left: '0',
          textStyle: { fontSize: 14, color: "#fff" }
        },
        {
          text: '地块面积(㎡)分布',
          right: '0',
          textStyle: { fontSize: 14, color: "#fff" }
        }],
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              title: '保存图片',
              name: "查询结果分析图表"
            }
          }
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            return params.name + "：" + params.value + "(" + params.percent + "%)";
          }
        },
        series: [
          {
            type: 'pie',
            radius: 90,
            center: ['25%', '50%'],
            label: {
              textStyle: {
                color: "#fff"
              }
            },
            labelLine: {
              lineStyle: {
                color: "#fff"
              }
            },
            data: cntData
          },
          {
            type: 'pie',
            radius: 90,
            center: ['75%', '50%'],
            label: {
              textStyle: {
                color: "#fff"
              }
            },
            labelLine: {
              lineStyle: {
                color: "#fff"
              }
            },
            data: areaData
          },
        ]
      };
      myChart.setOption(option);
      window.addEventListener('resize', () => { myChart.resize() });
    },
    initAttrPieChart() {
      let myChart = echarts.init(document.getElementById('pieChartDiv'));
      const pieData = Object.keys(this.searchResultLayers).map(key => {
        return {
          name: this.attrCanSearchLayerList.filter(l => l.value == key)[0]["label"],
          value: this.searchResultLayers[key].length
        };
      })
      const pieData1 = Object.keys(this.searchResultLayers).map(key => {
        const name = this.attrCanSearchLayerList.filter(l => l.value == key)[0]["label"];
        const val = this.searchResultLayers[key].reduce((fea1, fea2) => {
          if (fea2) {
            return fea1 + fea2.getGeometry().getArea();
          } else {
            this.$message.warn(name + "无法计算该要素面积");
            return 0;
          }
        }, 0)
        return {
          name: name,
          value: val.toFixed(2)
        };
      })
      const pieData2 = Object.keys(this.searchResultLayers).map(key => {
        const name = this.attrCanSearchLayerList.filter(l => l.value == key)[0]["label"];
        const val = this.searchResultLayers[key].reduce((fea1, fea2) => {
          if (fea2) {
            return fea1 + fea2.getGeometry().getArea() * 0.0015;
          } else {
            this.$message.warn(name + "无法计算该要素面积");
            return 0;
          }
        }, 0)
        return {
          name: name,
          value: val.toFixed(2)
        };
      })

      let option = {
        title: [{
          text: '各类用地数量分布',
          left: '0',
          textStyle: { fontSize: 14, color: "#fff" }
        },
        {
          text: '各类用地面积(㎡)分布',
          left: '34%',
          textStyle: { fontSize: 14, color: "#fff" }
        },
        {
          text: '各类用地面积(亩)分布',
          left: '67%',
          textStyle: { fontSize: 14, color: "#fff" }
        }],
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              title: '保存图片',
              name: "查询结果分析图表"
            }
          }
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            return params.name + "：" + params.value + "(" + params.percent + "%)";
          }
        },
        series: [
          {
            type: 'pie',
            radius: 90,
            center: ['17%', '50%'],
            label: {
              textStyle: {
                color: "#fff"
              }
            },
            labelLine: {
              lineStyle: {
                color: "#fff"
              }
            },
            data: pieData
          },
          {
            type: 'pie',
            radius: 90,
            center: ['50%', '50%'],
            label: {
              textStyle: {
                color: "#fff"
              }
            },
            labelLine: {
              lineStyle: {
                color: "#fff"
              }
            },
            data: pieData1
          },
          {
            type: 'pie',
            radius: 90,
            center: ['83%', '50%'],
            label: {
              textStyle: {
                color: "#fff"
              }
            },
            labelLine: {
              lineStyle: {
                color: "#fff"
              }
            },
            data: pieData2
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener('resize', () => { myChart.resize() });
    },
    saveMapState() {
      this.$httpPost("zserver/api/layers_visible", { userId: this.$store.state.user.id, layerIds: this.layerTreeCheckedKeys }).then(res => {
        if (res) {
          this.$message.success("保存成功", 2);
        }
      })
    },
    attrTabLabelChange(e) {
      this.showAttrTable(e.target.value);
    },
    getAttrTabLabel(layer) {
      return this.attrCanSearchLayerList.filter(l => l.value == layer)[0]["label"] + "(" + this.searchResultLayers[layer].length + ")";
    },
    toolBoxClick(notice) {
      switch (notice) {
        case "zoom_out":
          this.mapView.animate({ zoom: this.mapView.getZoom() == this.mapView.getMaxZoom() ? this.mapView.getZoom() : (this.mapView.getZoom() + 1) });
          break;
        case "zoom_in":
          this.mapView.animate({ zoom: this.mapView.getZoom() == this.mapView.getMinZoom() ? this.mapView.getZoom() : (this.mapView.getZoom() - 1) });
          break;
        case "full":
          this.mapView.fit(this.initExtent, {
            duration: 1000,
            easing: easeOut
          });
          break;
        case "left":
          this.undoInteraction.undo();
          break;
        case "right":
          this.undoInteraction.redo();
          break;
        case "pan":
          if (this.paintDraw) { this.map.removeInteraction(this.paintDraw); }
          break;
      }
    },
    cleanMap() {
      this.analysisResultLayers.forEach(lyr => {
        this.map.removeLayer(lyr);
      })
      const overlays = this.map.getOverlays();
      overlays.forEach(olay => {
        if (olay && olay.id && (olay.id.indexOf("measureTips") > -1 || olay.id == "blinkMarker" || olay.id == "bubbleMarker")) {
          this.map.removeOverlay(olay);
        } else {
          olay.hide();
        }
      })
      if (this.paintDraw) { this.map.removeInteraction(this.paintDraw); }
      this.graphicLayer.getSource().clear();
      if (this.paintSource) { this.paintSource.clear(); }
      if (this.searchResultSource) { this.searchResultSource.clear(); }
      if (this.measureLayer.getSource()) { this.measureLayer.getSource().clear(); }
      this.isShowAttrTable = false;
    },
    locXy() {
      if (parseFloat(this.locationXy.x) == "NaN" || parseFloat(this.locationXy.y) == "NaN") {
        this.$message.warn("无效坐标值", 2);
        return;
      }
      const x = parseFloat(this.locationXy.x);
      const y = parseFloat(this.locationXy.y);
      const imgElement = document.createElement("img");
      imgElement.src = './img/blink_bl.gif';
      imgElement.style = "width:32px;";
      const marker = new Overlay({
        element: imgElement,
        id: "blinkMarker"
      });
      marker.setPosition([x, y]);
      this.map.addOverlay(marker);
      this.map.getView().setCenter([x, y]);
    },
    closeXy() {
      this.locationXy.visible = false;
      this.map.removeOverlay(this.map.getOverlayById("blinkMarker"));
    },
    toolClick(menu) {
      this.swipeMapVisible = 1;
      if (this.paintDraw) { this.map.removeInteraction(this.paintDraw); }
      switch (menu) {
        case 'length':
          Measure.measure(this.map, "length")
          return;
        case 'area':
          Measure.measure(this.map, "area")
          return;
        case 'location':
          this.locationXy.visible = true;
          return;
        case 'point':
          this.paintDraw = new Draw({
            type: 'Point',
            source: this.paintSource,
          });
          break;
        case 'line':
          this.paintDraw = new Draw({
            type: 'LineString',
            source: this.paintSource,
          });
          break;
        case 'polygon':
          this.paintDraw = new Draw({
            type: 'Polygon',
            source: this.paintSource,
          });
          break;
      }
      let self = this;
      this.map.addInteraction(this.paintDraw);
      this.paintDraw.on('drawend', (e) => {
        this.map.removeInteraction(this.paintDraw);
        self.graphicLayer.setZIndex(1010);
        self.graphicLayer.getSource().addFeature(e.feature);
        this.makePopupContent(e.feature);
      });
      this.paintDraw.on("drawstart", (e) => {
        this.graphicAttr.memo = "";
        this.graphicAttr.geom = "";
        this.graphicAttr.p_group = format(new Date(), "yyyy-MM-dd");
        this.paintSource.clear(true);
        this.map.removeLayer(this.paintVector);
        this.map.addLayer(this.paintVector);
      })
    },
    makePopupContent(feature) {
      const popup = this.map.getOverlayById("extPopup");
      const wkt = new WKT();
      this.graphicAttr.geom = wkt.writeFeature(feature);
      if (feature.getGeometry().getType().indexOf("Point") > -1) {
        this.graphicAttr.label = "坐标";
        this.graphicAttr.value = feature.getGeometry().getLastCoordinate()[0] + "," + feature.getGeometry().getLastCoordinate()[1];
      } else if (feature.getGeometry().getType().indexOf("LineString") > -1) {
        this.graphicAttr.label = "长度";
        const length = feature.getGeometry().getLength();
        this.graphicAttr.value = length > 100 ? (Math.round(length / 1000 * 100) / 100 + "km") : (Math.round(length * 100) / 100 + "m");
      } else if (feature.getGeometry().getType().indexOf("Polygon") > -1) {
        this.graphicAttr.label = "面积";
        const area = feature.getGeometry().getArea();
        this.graphicAttr.value = area > 10000 ? (Math.round(area / 1000000 * 100) / 100 + "km²") : (Math.round(area * 100) / 100 + "m²");
      }
      this.graphicAttr.id = feature.getId();
      popup.show(feature.getGeometry().getLastCoordinate(), document.getElementById("extPopupContent"));
    },
    saveGraphic() {
      const params = {
        create_by: this.$store.state.user.login,
        geometry: this.graphicAttr.geom,
        memo: this.graphicAttr.memo,
        p_group: this.graphicAttr.p_group
      };
      if (this.graphicAttr.id) {
        params["id"] = this.graphicAttr.id;
        this.$httpPut("zserver/api/draws", params).then(res => {
          if (res) {
            this.$message.success("保存成功", 2);
            this.map.getOverlayById("extPopup").hide();
            this.getGraphicFromServer();
            this.graphicLayer.getSource().clear(true);
          }
        })
      } else {
        this.$httpPost("zserver/api/draws", params).then(res => {
          if (res) {
            this.$message.success("保存成功", 2);
            this.map.getOverlayById("extPopup").hide();
            const newId = res.data;
            this.getGraphicFromServer([newId]);
            this.graphicLayer.getSource().clear(true);
          }
        })
      }
    },
    menuClick(menu) {
      this.swipeMapVisible = 1;
      if (this.paintDraw) { this.map.removeInteraction(this.paintDraw); }
      switch (menu) {
        case "search_rect":
          this.initDrawRect();
          this.map.addInteraction(this.paintDraw);
          break;
        case "search_circle":
          this.paintDraw = new Draw({
            type: 'Circle',
            source: this.paintSource
          });
          this.map.addInteraction(this.paintDraw);
          break;
        case "search_polygon":
          this.paintDraw = new Draw({
            type: 'Polygon',
            source: this.paintSource,
          });
          this.map.addInteraction(this.paintDraw);
          break;
        case "search_point":
          this.paintDraw = new Draw({
            type: 'Point',
            source: this.paintSource,
          });
          this.map.addInteraction(this.paintDraw);
          break;
        case "search_attr":
          this.attrFilters = [];
          this.attrData = [];
          this.attrSelectedSearchLayer = undefined;
          this.attrFields = [];
          this.attrModalVisible = true;
          return;
        case "buffer_ana":
          this.bufferParams.save = false;
          this.bufferParams.name = "缓冲_" + format(new Date(), "yyyyMMddHHmmss");
          this.bufferParams.inputs = [undefined, 100];
          this.bufferModalVisible = true;
          return;
        case "intersect_ana":
          this.intersectParams.inputs = [undefined, undefined];
          this.intersectParams.name = "叠加_" + format(new Date(), "yyyyMMddHHmmss");
          this.intersectParams.save = false;
          this.intersectModalTitle = "叠加分析";
          this.intersectParams.method = "IntersectionFeatureCollection";
          this.intersectModalVisible = true;
          return;
        case "union_ana":
          this.intersectParams.inputs = [undefined, undefined];
          this.intersectParams.name = "联合_" + format(new Date(), "yyyyMMddHHmmss");
          this.intersectParams.save = false;
          this.intersectModalTitle = "联合分析";
          this.intersectParams.method = "UnionFeatureCollection";
          this.intersectModalVisible = true;
          return;
        case "compare_ana":
          this.swipeMapVisible = 2;
          this.$refs.swipeChild.$emit("initMap", this.layerMap);
          return;
        case "multi_window_ana_2":
          this.swipeMapVisible = 3;
          this.$refs.multiWindowChild.$emit("initMap", this.layerMap, 2);
          return;
        case "multi_window_ana_4":
          this.swipeMapVisible = 3;
          this.$refs.multiWindowChild.$emit("initMap", this.layerMap, 4);
          return;
        default:
          break;
      }
      this.paintDraw.on('drawend', (e) => {
        // this.map.removeInteraction(this.paintDraw);
        let geometry = e.feature.getGeometry()
        if (e.feature.getGeometry().getType() === "Circle") {
          geometry = new fromCircle(geometry, 64, 0)
        }
        // const wkt = new WKT();
        // console.log(wkt.writeFeature(e.feature));
        this.searchByGeom(geometry, "Polygon")
      });
      this.paintDraw.on("drawstart", (e) => {
        this.paintSource.clear(true);
        this.searchResultSource.clear(true);
        this.map.removeLayer(this.paintVector);
        this.map.addLayer(this.paintVector);
      })
    },
    executeBufferHandle() {
      if (this.bufferParams.inputs[0] && this.bufferParams.inputs[1] > 0) {
        this.executeWps(this.bufferParams);
      }
    },
    executeIntersectHandle() {
      if (this.intersectParams.inputs[0] && this.intersectParams.inputs[1]) {
        this.executeWps(this.intersectParams);
      }
    },
    executeWps(params) {
      let self = this;
      this.$httpPost("zserver/api/execute_wps", params).then(res => {
        if (res.data) {
          if (res.data.features.length == 0) {
            self.$message.warn("无有效分析结果", 2);
            return;
          }
          const bufferSource = new VectorSource({
            features: new GeoJSON().readFeatures(res.data)
          });
          const bufferLayer = new VectorLayer({
            source: bufferSource,
            style: new Style({
              stroke: new Stroke({
                color: 'yellow',
                width: 1,
              }),
              fill: new Fill({
                color: 'rgba(255, 255, 0, 0.1)',
              }),
            }),
          });
          self.map.addLayer(bufferLayer);
          self.analysisResultLayers.push(bufferLayer);
          self.bufferModalVisible = false;
          self.intersectModalVisible = false;

          this.getAnalysisResultFromServer();
        }
      })
    },
    addCondition() {
      this.attrFilters.push({
        field: undefined,
        value: undefined,
        condition: undefined,
        ano: "and"
      })
    },
    searchByAttr() {
      if (this.attrFilters.length == 0) {
        this.$message.warn("请至少设置一个条件", 2);
        return;
      }
      let filterInfo;
      if (this.attrFilters.length >= 1) {
        const filter = this.attrFilters[0];
        if (filter.field && filter.condition && filter.value) {
          filterInfo = this.makeFilterInfo(filter);
        }
      }
      for (let i = 1; i < this.attrFilters.length; i++) {
        if (i == 0) {
          continue;
        }
        const filter = this.attrFilters[i];
        if (filter.field && filter.condition && filter.value) {
          if (filter.ano == "and") {
            filterInfo = new andFilter(filterInfo, this.makeFilterInfo(filter));
          }
          if (filter.ano == "or") {
            filterInfo = new orFilter(filterInfo, this.makeFilterInfo(filter));
          }
        }
      }

      const featureRequest = new WFS().writeGetFeature({
        srsName: "EPSG:990000",
        featureNS: "zhc",
        featurePrefix: "zhc",
        featureTypes: [this.attrSelectedSearchLayer],
        outputFormat: "application/json",
        filter: filterInfo
      });
      this.searchResultLayers = {};
      this.attrModalVisible = false;
      this.searchResultSource.clear(true);
      this.$httpPost(process.env.VUE_APP_GEOSERVER_ROOT + "wfs", new XMLSerializer().serializeToString(featureRequest), { "Content-Type": "text/plain;charset=UTF-8" }).then(res => {
        const features = new GeoJSON().readFeatures(res.data)
        this.attrTotal = res.data.totalFeatures
        if (this.attrTotal == 0) {
          this.$message.warn("未查询到数据", 2);
          return;
        }
        features.forEach(feature => {
          const id = feature.getId()
          const layerName = id.split(".")[0]
          if (!this.searchResultLayers[layerName]) {
            this.searchResultLayers[layerName] = []
          }
          this.searchResultLayers[layerName].push(feature);
        })
        const firstLayer = Object.keys(this.searchResultLayers)[0];
        this.showAttrTable(firstLayer);
        this.searchResultSource.addFeatures(features)
      })
    },
    makeFilterInfo(filter) {
      let filterInfo;
      if (filter.condition === "equalTo") {
        filterInfo = new equalToFilter(filter.field, filter.value);
      }
      if (filter.condition === "notEqualTo") {
        filterInfo = new notEqualTo(filter.field, filter.value);
      }
      if (filter.condition === "greaterThan") {
        filterInfo = new greaterThanFilter(filter.field, filter.value);
      }
      if (filter.condition === "greaterThanOrEqualTo") {
        filterInfo = new greaterThanOrEqualTo(filter.field, filter.value);
      }
      if (filter.condition === "lessThan") {
        filterInfo = new lessThanFilter(filter.field, filter.value);
      }
      if (filter.condition === "lessThanOrEqualTo") {
        filterInfo = new lessThanOrEqualTo(filter.field, filter.value);
      }
      if (filter.condition === "like") {
        filterInfo = new likeFilter(filter.field, "*" + filter.value + "*");
      }
      return filterInfo;
    },
    layerSelectedChange(value) {
      const featureRequest = new WFS().writeGetFeature({
        srsName: "EPSG:990000",
        featureNS: "zhc",
        featurePrefix: "zhc",
        featureTypes: [value],
        outputFormat: "application/json",
        // maxFeatures: 1
      })
      this.featuresData = [];
      this.oneFieldValues = [];

      this.$httpGet(`zserver/api/layer_fields?layer=${value}`).then(res => {
        if (res && res.data) {
          this.attrFields = res.data.map(fieldMap => {
            return { label: fieldMap.n_field, value: fieldMap.o_field };
          })

          this.$httpPost(process.env.VUE_APP_GEOSERVER_ROOT + "wfs", new XMLSerializer().serializeToString(featureRequest), { "Content-Type": "text/plain;charset=UTF-8" }).then(res => {
            this.featuresData = new GeoJSON().readFeatures(res.data);
            this.attrTotal = res.data.totalFeatures
          })

        } else {
          this.$message.warn("未获取到字段信息", 2);
        }
      })
    },
    searchByGeom(geom, type) {
      const layerArray = this.map.getLayers();
      const searchLayers = Object.keys(this.layerMap).map(key => this.layerMap[key]).filter(layerInfo => layerInfo.layer.getVisible() && layerInfo.type == "矢量").map(layerInfo => layerInfo.key)
      if (searchLayers.length == 0) {
        this.$message.warn("当前没有可查询的可见图层", 2);
        return
      }
      const featureRequest = new WFS().writeGetFeature({
        srsName: "EPSG:990000",
        featureNS: "zhc",
        featurePrefix: "zhc",
        featureTypes: searchLayers,
        outputFormat: "application/json",
        filter: new Intersects("the_geom", geom, "EPSG:990000")
      })
      this.searchResultLayers = {};
      this.$httpPost(process.env.VUE_APP_GEOSERVER_ROOT + "wfs", new XMLSerializer().serializeToString(featureRequest), { "Content-Type": "text/plain;charset=UTF-8" }).then(res => {
        const features = new GeoJSON().readFeatures(res.data)
        this.attrTotal = res.data.totalFeatures
        if (this.attrTotal == 0) {
          this.$message.warn("未查询到数据", 2);
          return;
        }
        features.forEach(feature => {
          const id = feature.getId()
          const layerName = id.split(".")[0]
          if (!this.searchResultLayers[layerName]) {
            this.searchResultLayers[layerName] = []
          }
          this.searchResultLayers[layerName].push(feature);
        })
        const firstLayer = Object.keys(this.searchResultLayers)[0];
        this.showAttrTable(firstLayer);
        this.searchResultSource.addFeatures(features)
      })
    },
    showAttrTable(key) {
      this.isShowAttrTable = true;
      this.attrTableSelectedLabel = key;
      this.attrPieChartVisible = false;
      this.selectedChartField = undefined;
      const features = this.searchResultLayers[key];
      this.$httpGet(`zserver/api/layer_fields?layer=${key}`).then(res => {
        if (res && res.data) {
          this.attrColumns = res.data.filter(fieldMap => fieldMap.show == '1').map(fieldMap => {
            if (fieldMap.o_field == "照片ID" || fieldMap.o_field == "DKBH" || fieldMap.o_field == "地块编号") {
              return { title: "现场照片", dataIndex: fieldMap.o_field, className: "dd-row-click", scopedSlots: { customRender: 'picLink' } };
            }
            return { title: fieldMap.n_field, dataIndex: fieldMap.o_field, className: "dd-row-click" };
          });

          this.attrData = features.map(feature => {
            let props = feature.getProperties();
            props["key"] = feature.getId();
            props["feature"] = feature;
            return props;
          })
          this.jsonFields = {};
          res.data.forEach(p => {
            this.jsonFields[p.o_field] = p.o_field;
          });
          this.jsonData = features.map(feature => {
            let props = feature.getProperties();
            delete props["geometry"];
            return props;
          });
        }
      })
      // if (this.attrPieChartVisible) {
      //   this.initAttrPieChart();
      // }
    },
    rowClick(record, index) {
      return {
        on: {
          click: (e) => {
            // this.searchResultSource.clear(true);
            // this.searchResultSource.addFeature(record["feature"]);
            const oldStyle = new Style({
              stroke: new Stroke({
                fill: null,
                color: '#10d7f7',
                width: 4,
              }),
            });
            if (this.lastSelectedFeature && this.searchResultSource.hasFeature(this.lastSelectedFeature)) {
              this.lastSelectedFeature.setStyle(oldStyle);
            }
            if (this.lastSelectedFeature && this.searchResultSource.hasFeature(this.lastSelectedFeature) && this.lastSelectedFeature.get("uid") == 1) {
              this.searchResultSource.clear(true);
            }
            this.lastSelectedFeature = record["feature"];
            if (this.searchResultSource.getFeatures().length == 0) {
              this.lastSelectedFeature.set("uid", 1);
              this.searchResultSource.addFeature(this.lastSelectedFeature);
            }
            if (record["feature"]) {
              const newStyle = new Style({
                fill: new Fill({
                  color: '#ffaa00',
                }),
                stroke: new Stroke({
                  color: '#ffaa00',
                  width: 4,
                }),
              });
              record["feature"].setStyle(newStyle);
              const geom = record["feature"].getGeometry();
              this.map.getView().fit(geom.getExtent());

              if (this.map.getOverlayById("bubbleMarker")) {
                this.map.removeOverlay(this.map.getOverlayById("bubbleMarker"));
                this.map.getOverlayById("extPopup").hide();
              }
              const imgElement = document.createElement("img");
              imgElement.src = './img/po_marker.png';
              imgElement.style = "width:32px;";
              const marker = new Overlay({
                element: imgElement,
                id: "bubbleMarker",
                offset: [-16, -32]
              });
              if (geom.getType().indexOf("Point") > -1) {
                marker.setPosition(geom.getCoordinates());
              } else if (geom.getType().indexOf("LineString") > -1) {
                marker.setPosition(geom.getCoordinateAt(0));
              } else if (geom.getType().indexOf("MultiPolygon") > -1) {
                marker.setPosition(geom.getInteriorPoints().getLastCoordinate());
              } else if (geom.getType().indexOf("Polygon") > -1) {
                marker.setPosition(geom.getInteriorPoint().getLastCoordinate());
              }
              this.map.addOverlay(marker);
              imgElement.addEventListener("click", (e) => {
                const popup = this.map.getOverlayById("extPopup");
                let content = "";
                for (let attr of this.attrColumns) {
                  content += "<span style='font-weight:bold'>" + attr.title + "</span>：" + record[attr.dataIndex] + "<br>";
                }
                content = "<div style='max-height:400px; max-width:400px;overflow:auto;'>" + content + "</div>";
                popup.show(marker.getPosition(), content);
              })
            }
          }
        }
      }
    },
    showPicList(text) {
      this.$httpGet(`zserver/api/pic_list?layer=${this.attrTableSelectedLabel}&bh=${text}`).then(res => {
        if (res && res.data) {
          this.dkImages = res.data.map(imgName => `${process.env.VUE_APP_ATTACH_ROOT}${this.attrTableSelectedLabel}/${text}/${imgName}`);
          const viewer = this.$el.querySelector('.dd-viewer-images').$viewer
          viewer.show()
        } else {
          this.$message.warn("无照片数据");
        }
      })

    },
    initMap() {
      proj4.defs('EPSG:990000', epsg9900.define);
      register(proj4);
      const projection = new Projection({
        code: "EPSG:990000",
        units: epsg9900.units,
        extent: epsg9900.extent
      });

      const tileSource = new XYZ({
        maxZoom: 8,
        minZoom: 0,
        projection: projection,
        transition: 0,
        tileGrid: new TileGrid({
          tileSize: 256,
          origin: epsg9900.origin,
          extent: epsg9900.extent,
          resolutions: epsg9900.tile_resolutions
        }),
        tileUrlFunction: (tileCoord) => {
          const z = "L" + this.zeroPad(tileCoord[0], 2, 10);
          const x = "C" + this.zeroPad(tileCoord[1], 8, 16);
          const y = "R" + this.zeroPad(tileCoord[2], 8, 16);
          return `${process.env.VUE_APP_BASEMAP}/Layers/_alllayers/${z}/${y}/${x}.png`;
        }
      })
      const baseLayer = new TileLayer({
        id: "base_layer_0",
        source: tileSource,
        wrapX: true
      });

      this.map = new Map({
        target: 'mapDiv',
        layers: [baseLayer],
        controls: olControl.defaults({
          zoom: false
        }),
        view: new View({
          projection: projection,
          center: [(epsg9900.initExtent[0] + epsg9900.initExtent[2]) / 2, (epsg9900.initExtent[1] + epsg9900.initExtent[3]) / 2],
          zoom: 5,
          minZoom: 0,
          maxZoom: 8
        })
      });

      this.getLayerTree();

      this.mapView = this.map.getView();

      this.initUndoRedo();

      this.map.on("singleclick", (e) => {
        // console.log(e);
        const feature = this.map.forEachFeatureAtPixel(e.pixel, (feature, layer) => { return feature; });
        if (feature && this.graphicLayerFromServer.getSource().hasFeature(feature)) {
          this.graphicAttr.memo = feature.getProperties()["memo"] || "";
          this.graphicAttr.p_group = feature.getProperties()["p_group"] || "";
          this.makePopupContent(feature);
        }
      });

      const srLayer = new VectorLayer({
        source: this.searchResultSource,
        style: new Style({
          stroke: new Stroke({
            color: '#10d7f7',
            width: 4,
          }),
        }),
      });
      this.map.addLayer(srLayer)
      srLayer.setZIndex(100);
      this.initDrawParams();

      this.initGraphicLayer();
      this.measureLayer = new VectorLayer({
        source: new VectorSource(),
        zIndex: 1005,
        name: "measure-layer",
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)',
          }),
          stroke: new Stroke({
            color: '#ffcc33',
            width: 2,
          }),
          image: new Circle({
            radius: 7,
            fill: new Fill({
              color: '#ffcc33',
            }),
          }),
        }),
      })
      this.map.addLayer(this.measureLayer);

      this.initExtPopup();
      this.initPrintControl();
    },
    zeroPad(num, len, radix) {
      let str = num.toString(radix || 10);
      while (str.length < len) {
        str = "0" + str;
      }
      return str;
    },
    initPrintControl() {
      this.printControl = new Print();
      this.map.addControl(this.printControl);
      this.printControl.on('printing', (e) => {
        // console.log(e);
      });
      this.printControl.on(['print', 'error'], (e) => {
        if (e.image) {
          //for ie 11+
          if (!HTMLCanvasElement.prototype.toBlob) {
            Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
              value: function (callback, type, quality) {
                var canvas = this;
                setTimeout(function () {
                  var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]);
                  var len = binStr.length;
                  var arr = new Uint8Array(len);

                  for (var i = 0; i < len; i++) {
                    arr[i] = binStr.charCodeAt(i);
                  }

                  callback(new Blob([arr], { type: type || 'image/png' }));
                });
              }
            });
          }

          e.canvas.toBlob((blob) => {
            saveAs(blob, 'map.' + e.imageType.replace('image/', ''));
          }, e.imageType);
        } else {
          console.warn('No canvas to export' + e);
          this.$message.warn("当前浏览器不支持");
        }
      });
    },
    initExtPopup() {
      const popup = new ExtPopup({
        id: "extPopup",
        popupClass: "default", //"tooltips", "warning" "black" "default", "tips", "shadow",
        closeBox: true,
        onshow: function () { console.log("You opened the box"); },
        onclose: function () { console.log("You close the box"); },
        positioning: 'top-auto',
        autoPan: true,
        autoPanAnimation: { duration: 250 }
      });
      this.map.addOverlay(popup);
    },
    initUndoRedo() {
      this.undoInteraction = new UndoRedo();
      this.lastExtent = this.mapView.calculateExtent(this.map.getSize());
      this.mapView.on("change", (e) => {
        const before = this.lastExtent;
        this.lastExtent = this.mapView.calculateExtent(this.map.getSize());
        if (!equals(before, this.lastExtent)) {
          this.undoInteraction.push("extent", { before: before, after: this.lastExtent });
        }
      });
      this.undoInteraction.define("extent", (s) => {
        const before = s.before;
        this.mapView.fit(before, {
          nearest: true,
          duration: 1000,
          easing: easeOut
        })
      }, (s) => {
        const after = s.after;
        this.mapView.fit(after, {
          nearest: true,
          duration: 1000,
          easing: easeOut
        })
      });
    },
    initDrawParams() {
      this.paintSource = new VectorSource({ wrapX: false });
      this.paintVector = new VectorLayer({
        source: this.paintSource,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.5)'
          }),
          stroke: new Stroke({
            color: 'blue',
            width: 1
          })
        })
      });
      this.map.addLayer(this.paintVector);
    },
    initDrawRect() {
      this.paintDraw = new Draw({
        source: this.paintSource,
        type: 'LineString',
        maxPoints: 2,
        geometryFunction: (coordinates, geometry) => {
          if (!geometry) {
            geometry = new Polygon([]);
          }
          var start = coordinates[0];
          var end = coordinates[1];
          geometry.setCoordinates([
            [start, [start[0], end[1]], end, [end[0], start[1]], start]
          ]);
          return geometry;
        }
      })
    },
    getLayerTree() {
      this.$httpGet(`zserver/api/layers_tree?userId=${this.$store.state.user.id}`).then(res => {
        res.data.forEach(node => {
          // if (node.title == "基础图层") {
          //   this.treeBaseLayerData = node.children;
          //   this.treeBaseLayerData.forEach(child => {
          //     this.addWmsLayer(child, true);
          //   })
          //   return;
          // }
          // if (node.is_basemap == "1") {
          //   this.treeBaseMapData.push(node);
          //   this.addWmsLayer(node);
          //   return;
          // }
          if (node.type == "矢量") {
            node["scopedSlots"] = { title: "layer-title" };
          }
          if (node.type == "分组") {
            const children = node.children;
            children.forEach(child => {
              if (child.type == "矢量") {
                child["scopedSlots"] = { title: "layer-title" };
              }
            })
          }
          this.treeData.push(node);
        })

        if (this.treeData.length > 0) {
          this.attrCanSearchLayerList = [];
          for (let index = this.treeData.length - 1, len = this.treeData.length; index > -1; index--) {
            const node = this.treeData[index];
            if (node.type == "分组") {
              const children = node.children;
              children.forEach(child => {
                this.addWmsLayer(child);
              })
            } else {
              this.addWmsLayer(node);
            }
          }

          if (this.layerTreeCheckedKeys.length > 0) {
            const lastLayerInfo = Object.keys(this.layerMap).map(key => this.layerMap[key]).filter(lyr => lyr.layer.getVisible())[0] || null;
            if (lastLayerInfo) {
              this.map.getView().setCenter(lastLayerInfo["center"]);
            }
          }
        }
      })
    },
    treeNodeCheck(checkedKeys, info) {
      const props = info.node.$vnode.data.props;
      if (info.checked) {
        if (props.type === "分组") {
          const children = info.node.$vnode.data.props.dataRef.children;
          children.forEach(child => {
            this.setWmsLayerVisible(child.layer, true)
          })
        } else {
          this.setWmsLayerVisible(props.layer, true)
        }
      } else {
        if (props.type === "分组") {
          const children = info.node.$vnode.data.props.dataRef.children;
          children.forEach(child => {
            if (child.layer && this.layerMap[child.layer]) {
              this.setWmsLayerVisible(child.layer, false)
            }
          })
        } else {
          if (props.layer && this.layerMap[props.layer]) {
            this.setWmsLayerVisible(props.layer, false)
          }
        }
      }
    },
    addWmsLayer(layerInfo, isBase) {
      if (!layerInfo || layerInfo.type == "分组") {
        return;
      }
      if (!isBase) {
        if (layerInfo.type == "矢量") {
          this.attrCanSearchLayerList.push({ label: layerInfo.title, value: layerInfo.layer });
        }
        if (layerInfo.visible == "1") {
          this.layerTreeCheckedKeys.push(layerInfo.key);
        }
      }
      let tileLayer;
      if (this.isPngLayer(layerInfo.geometry_type)) {
        tileLayer = new ImageLayer({
          visible: layerInfo.visible == "1" ? true : false,
          id: `raster_layer_${layerInfo.layer}`,
          source: new Static({
            url: `${process.env.VUE_APP_STATIC_ROOT + layerInfo.layer}/${layerInfo.layer + layerInfo.geometry_type}`,
            imageExtent: JSON.parse(layerInfo.bbox),
            transition: 0
          })
        });
      } else {
        tileLayer = new TileLayer({
          visible: layerInfo.visible == "1" ? true : false,
          id: layerInfo.layer,
          source: new TileWMS({
            url: process.env.VUE_APP_GEOSERVER_ROOT + "wms?",
            params: {
              'LAYERS': "chs:" + layerInfo.layer,
              'TILED': true
            },
            serverType: 'geoserver',
            transition: 0
          })
        });
      }
      this.layerMap[layerInfo.layer] = {
        "layer": tileLayer,
        "geometry_type": layerInfo.geometry_type,
        "type": layerInfo.type,
        "bbox": JSON.parse(layerInfo.bbox),
        "key": layerInfo.layer,
        "center": JSON.parse(layerInfo.center),
        "name": layerInfo.title,
        "isBase": isBase ? true : false //基础图层
      }
      this.map.addLayer(tileLayer);
    },
    setWmsLayerVisible(layerName, visible) {
      if (this.layerMap[layerName]["layer"]) {
        this.layerMap[layerName]["layer"].setVisible(visible);
        if (visible) {
          // this.map.getView().fit(this.layerMap[layerName]["bbox"], this.map.getSize())
          this.map.getView().setCenter(this.layerMap[layerName]["center"]);
        }
      }
    },
    isPngLayer(ext) {
      if (".png".toLowerCase() == ext || ".jpg".toLowerCase() == ext || ".jpeg".toLowerCase() == ext) {
        return true;
      }
      return false;
    },
    initGraphicLayer() {
      this.graphicLayer = new VectorLayer({
        source: new VectorSource(),
        style: this.graphicStyleFunction
      });
      this.graphicLayerFromServer = new VectorLayer({
        source: new VectorSource(),
        style: this.graphicStyleFunction
      });
      this.map.addLayer(this.graphicLayerFromServer);
      this.map.addLayer(this.graphicLayer);
    },
    graphicStyleFunction(feature) {
      if (feature.getGeometry().getType().indexOf("Point") > -1) {
        return new Style({
          image: new Icon({
            anchor: [16, 32],
            anchorXUnits: 'pixels',
            anchorYUnits: 'pixels',
            src: './img/point_marker.png',
          }),
        });
      } else if (feature.getGeometry().getType().indexOf("LineString") > -1) {
        return new Style({
          stroke: new Stroke({
            color: 'red',
            width: 4,
          }),
        })
      } else if (feature.getGeometry().getType().indexOf("Polygon") > -1) {
        return new Style({
          stroke: new Stroke({
            color: 'red',
            lineDash: [4],
            width: 4,
          }),
          fill: new Fill({
            color: 'rgba(0, 0, 255, 0.1)',
          }),
        })
      }
    },
    getGraphicFromServer(ids) {
      let self = this;
      self.graphicLayerFromServer.getSource().clear(true);
      this.$httpGet("zserver/api/draws").then(res => {
        if (res.data) {
          const wkt = new WKT();
          let selectedFeatures = [];
          this.treeGraphicData = res.data.map(group => {
            const children = group.children.map(graphic => {
              const feature = wkt.readFeature(graphic.geometry);
              feature.setProperties({ memo: graphic.memo });
              feature.setProperties({ p_group: graphic.p_group });
              feature.setId(graphic.id);
              if (this.treeGraphicSelectedKeys.indexOf(graphic.id) > -1 || (ids && ids.indexOf(graphic.id) > -1)) {
                selectedFeatures.push(feature);
              }
              return { title: graphic.memo, scopedSlots: { title: "graphic-title" }, key: graphic.id, feature: feature };
            });
            group.children = children;
            return { title: group.title, scopedSlots: { title: "dategroup-title" }, key: group.key, children: children };
          });
          self.graphicLayerFromServer.getSource().addFeatures(selectedFeatures);
          if (ids) {
            ids.forEach(id => {
              self.treeGraphicSelectedKeys.push(id);
            })
          }
        }
      })
    },
    deleteGraphic(key) {
      if (key) {
        if (this.treeGraphicSelectedKeys.indexOf(key) > -1) {
          this.treeGraphicSelectedKeys = this.treeGraphicSelectedKeys.filter(k => k != key);
        }
        this.$httpDel(`zserver/api/draws/${key}`).then(res => {
          if (res.data) {
            this.$message.success("已删除");
            this.treeGraphicData = this.treeGraphicData.map(group => {
              const children = group.children.filter(graphic => graphic.key !== key);
              group.children = children;
              return group;
            });
            if (this.graphicLayerFromServer.getSource().getFeatureById(key)) {
              this.graphicLayerFromServer.getSource().removeFeature(this.graphicLayerFromServer.getSource().getFeatureById(key));
            }
          }
        })
      }
    },
    treeGraphicCheck(checkedKeys, info) {
      const props = info.node.$vnode.data.props;
      if (info.checked) {
        if (!props.dataRef.feature) {
          props.dataRef.children.forEach(graphic => {
            if (!this.graphicLayerFromServer.getSource().hasFeature(graphic.feature) && graphic.feature) {
              this.graphicLayerFromServer.getSource().addFeature(graphic.feature);
            }
          })
          this.mapView.fit(this.graphicLayerFromServer.getSource().getExtent());
        } else {
          if (!this.graphicLayerFromServer.getSource().hasFeature(props.feature) && props.feature) {
            this.graphicLayerFromServer.getSource().addFeature(props.feature);
            this.mapView.fit(this.graphicLayerFromServer.getSource().getExtent());
          }
        }

      } else {
        if (!props.dataRef.feature) {
          props.dataRef.children.forEach(graphic => {
            if (this.graphicLayerFromServer.getSource().hasFeature(graphic.feature)) {
              this.graphicLayerFromServer.getSource().removeFeature(graphic.feature);
            }
          })
        } else {
          if (props.feature) {
            this.graphicLayerFromServer.getSource().removeFeature(props.feature);
          }
        }
      }
    },
    exportGraph(date) {
      this.$httpGet(`zserver/api/export_draws?dateStr=${date}`).then(res => {
        if (res.data) {
          this.downloadVector({ layer: res.data });
        }
      })
    },
    exportAnalysis(id) {
      this.$httpGet(`zserver/api/export_analysis?id=${id.replace("analysis_", "")}`).then(res => {
        if (res.data) {
          this.downloadVector({ layer: res.data });
        }
      })
    },
    treeBaseNodeCheck(checkedKeys, info) {
      const props = info.node.$vnode.data.props;
      if (info.checked) {
        this.setWmsLayerVisible(props.layer, true)
      } else {
        if (props.layer && this.layerMap[props.layer]) {
          this.setWmsLayerVisible(props.layer, false)
        }
      }
    },
    getAnalysisResultFromServer() {
      this.$httpGet("zserver/api/analysises").then(res => {
        if (res.data) {
          this.treeAnalysisData = res.data.map(d => {
            const bufferSource = new VectorSource({
              features: new GeoJSON().readFeatures(d.result)
            });
            const bufferLayer = new VectorLayer({
              source: bufferSource,
              visible: false,
              id: "analysis_" + d.id,
              style: new Style({
                stroke: new Stroke({
                  color: 'yellow',
                  width: 1,
                }),
                fill: new Fill({
                  color: 'rgba(255, 255, 0, 0.1)',
                }),
              }),
            });
            const l = this.getLayerById("analysis_" + d.id);
            if (l) {
              this.map.removeLayer(l);
            }
            this.map.addLayer(bufferLayer);
            return { key: "analysis_" + d.id, title: d.name, scopedSlots: { title: "analysis-title" } };
          })
          this.analysisResultLayerFromServer = res.data;
        }
      })
    },
    deleteAnalysis(key) {
      if (key) {
        this.$httpDel(`zserver/api/analysises/${key.replace("analysis_", '')}`).then(res => {
          if (res.data) {
            this.$message.success("已删除");
            this.treeAnalysisData = this.treeAnalysisData.filter(ana => ana.key !== key);
            const l = this.getLayerById(key);
            if (l) {
              this.map.removeLayer(l);
            }
          }
        })
      }
    },
    treeAnalysisNodeCheck(checkeys, info) {
      const props = info.node.$vnode.data.props.dataRef;
      const l = this.getLayerById(props.key);
      if (!l) {
        return;
      }
      if (info.checked) {
        l.setVisible(true);
      } else {
        l.setVisible(false);
      }
    },
    treeBaseMapCheck(checkeys, info) {
      const props = info.node.$vnode.data.props.dataRef;
      let l;
      if (props.key == 0) {
        l = this.getLayerById("base_layer_0");
      } else {
        l = this.layerMap[props.layer].layer;
      }
      if (l) {
        if (info.checked) {
          l.setVisible(true);
        } else {
          l.setVisible(false);
        }
      }
    },
    getLayerById(id) {
      for (let l of this.map.getLayers().getArray()) {
        if (l.get("id") == id) {
          return l;
        }
      }
      return undefined;
    },
    checkDog() {
      //Get object
      const objAuth = getAuthObject();
      if ((navigator.userAgent.indexOf("Chrome") > 0) || (navigator.userAgent.indexOf("Firefox") > 0)) {
        objAuth.GetUserNameEx(this.scope, this.authCode);
      } else {
        //Open Dog
        let stat = objAuth.Open(this.scope, this.authCode);
        if (0 != stat) {
          this.$message.warn(reportStatus(stat));
        } else {
          stat = objAuth.GetUserName();
          if (stat != 0) {
            objAuth.Close();
            this.$message.warn(reportStatus(stat));
            dbTool.clear();
            this.$router.push("/login");
          }
        }
      }
      //Execute the check again after 2 seconds
      this.$global.timer = setTimeout(this.checkDog, 2000);
    },
    layerOrderChange(info) {
      const dropKey = info.node.eventKey;
      const dragKey = info.dragNode.eventKey;
      const dropPos = info.node.pos.split('-');
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
      const loop = (data, key, callback) => {
        data.forEach((item, index, arr) => {
          if (item.key === key) {
            return callback(item, index, arr);
          }
        });
      };
      const data = [...this.treeData];
      // Find dragObject
      let dragObj;
      loop(data, dragKey, (item, index, arr) => {
        arr.splice(index, 1);
        dragObj = item;
      });
      let ar;
      let i;
      loop(data, dropKey, (item, index, arr) => {
        ar = arr;
        i = index;
      });
      if (dropPosition === -1) {
        ar.splice(i, 0, dragObj);
      } else {
        ar.splice(i + 1, 0, dragObj);
      }
      this.treeData = data;

      const dragProps = info.dragNode.$vnode.data.props;
      const dropProps = info.node.$vnode.data.props;
      const dragLayer = this.layerMap[dragProps.layer].layer;
      const dropLayer = this.layerMap[dropProps.layer].layer;
      this.map.getLayers().getArray().some((layer, index) => {
        if (dragProps.layer == layer.get("id")) {
          this.map.getLayers().getArray().splice(index, 1);
          return true;
        }
      })
      this.map.getLayers().getArray().some((layer, index) => {
        if (dropProps.layer == layer.get("id")) {
          this.map.getLayers().getArray().splice(index + 1, 0, dragLayer);
          return true;
        }
      })
      this.map.render();
    },
  },
  mounted() {
    this.$store.state.loading = true;
    setTimeout(() => {
      this.initMap();
      this.$store.state.loading = false;
      this.getGraphicFromServer();
      this.getAnalysisResultFromServer();

      // if (this.$global.timer) {
      //   clearTimeout(this.$global.timer);
      // }
      // window.parent.onmessage = e => {
      //   let self = this;
      //   if (event.data.type == "SNTL_FROM_HOST") {
      //     var ReturnText = event.data.text;
      //     if ("GetUserNameEx" == ReturnText.InvokeMethod) {
      //       if (0 == ReturnText.Status) {
      //         if (!ReturnText.UserNameStr) {
      //           this.$message.warn("当前狗中缺少有效用户信息")
      //         }
      //       } else {
      //         this.$message.warn(reportStatus(parseInt(ReturnText.Status)));
      //         self.$router.push("/login");
      //       }
      //     }
      //   }
      // }
      // this.checkDog();

    }, 1000);
  }

}
</script>

<style scoped lang="scss">
.dd-layout {
  width: 100%;
  height: 100%;
  .ant-layout-header {
    background: rgba(13, 25, 68, 0.9);
    background-image: url("../assets/header_bg.png");
    box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.35);
    background-size: 100% 100%;
  }
  .dd-sider-trigger {
    z-index: 1010;
    min-width: 76px;
    width: 300px;
    height: 46px;
    top: 0px;
    left: 0px;
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.11);
    opacity: 0.9;
    line-height: 46px;
    padding-left: 15px;
    padding-right: 15px;
    position: absolute;

    .dd-open-arrow,
    .dd-arrow {
      position: absolute;
      right: 10px;
      top: 17px;
      line-height: 0;
      cursor: pointer;
      & > div {
        display: inline-block;
        background-size: 100%;
        width: 6px;
        height: 11px;
        background-image: url("../assets/left_unselected.png");
      }
    }
    .dd-open-arrow {
      & > div {
        display: inline-block;
        background-size: 100%;
        width: 6px;
        height: 11px;
        background-image: url("../assets/right_unselected.png");
      }
    }
    & > .dd-arrow:hover {
      & > div {
        background-size: 100%;
        background-image: url("../assets/left_selected.png");
      }
    }
    & > .dd-open-arrow:hover {
      & > div {
        background-size: 100%;
        background-image: url("../assets/right_selected.png");
      }
    }
  }
  .dd-slider {
    position: absolute;
    width: 300px;
    top: 0px;
    left: 0px;
    height: 100%;
    background: linear-gradient(
      to right,
      rgba(13, 25, 68, 0.9),
      rgba(13, 25, 68, 0)
    );
    z-index: 1001;
    padding-top: 5px;
  }
  .dd-chart-container {
    height: 230px;
    width: 100%;
  }
}
.dd-map {
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
}
.dd-attr-table {
  // width: 70%;
  // height: 285px;
  background: rgba(99, 100, 105, 0.7);
  z-index: 1003;
  position: absolute;
  bottom: 0px;
  right: 100px;
}
.dd-user-icon {
  background: none !important;
  color: #fff !important;
}
.dd-must-has::before {
  display: inline-block;
  margin-right: 4px;
  color: #f5222d;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
}
.dd-right-toolbar {
  border-radius: 5px;
  z-index: 1010;
  top: 150px;
  right: 0px;
  position: absolute;
  width: 36px;
  height: auto;
  background: rgba(13, 25, 68, 0.9);
  box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.64);
  opacity: 0.85;
  & > div {
    text-align: center;
    height: 100%;
    line-height: 36px;
    & > img {
      cursor: pointer;
    }
  }
}
.dd-table-footer {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
}
.dd-ext-popup-content {
  display: none;
  .ant-col {
    margin-top: 5px;
  }
}
.dd-legend-panel {
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: calc(100% - 16rem - 250px);
  color: #ffffff;
  padding: 10px;
  width: 100%;

  & > div {
    height: calc(100% - 20px);
    overflow-y: auto;
    & > div {
      padding-left: 30px;
      & > span {
        display: block;
      }
    }
  }

  & > span {
    width: 100%;
    display: block;
    height: 20px;
    font-weight: bold;
  }
}
</style>
<style lang="scss">
.dd-attr-title {
  padding: 8px 16px;
  font-family: FZLanTingHei-DB-GBK;
  font-weight: 400;
  color: #fff;
  border: none;
  background: rgba(13, 25, 68, 0.7);

  & .dd-field-left {
    position: absolute;
    left: 0px;
    top: 45px;
    z-index: 1000;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      color: deepskyblue;
    }
  }

  & .dd-field-right {
    position: absolute;
    right: 0px;
    top: 45px;
    font-size: 16px;
    z-index: 1000;
    cursor: pointer;
    &:hover {
      color: deepskyblue;
    }
  }
}

td.dd-row-click {
  cursor: pointer !important;
}
.ant-row-flex-middle {
  margin-bottom: 10px;
  font-family: FZLanTingHei-DB-GBK;
  font-weight: 400;
  color: #3b3b3b;
}

.ol-tooltip {
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  color: white;
  padding: 4px 8px;
  opacity: 0.7;
  white-space: nowrap;
  font-size: 12px;
}
.ol-tooltip-measure {
  opacity: 1;
  font-weight: bold;
}
.ol-tooltip-static {
  background-color: #ffcc33;
  color: black;
  border: 1px solid white;
}
.ol-tooltip-measure:before,
.ol-tooltip-static:before {
  border-top: 6px solid rgba(0, 0, 0, 0.5);
  border-right: 6px solid transparent;
  border-left: 6px solid transparent;
  content: "";
  position: absolute;
  bottom: -6px;
  margin-left: -7px;
  left: 50%;
}
.ol-tooltip-static:before {
  border-top-color: #ffcc33;
}
.ol-tooltip-hidden {
  display: none;
}
.dd-collapse {
  margin-left: 10px;
  margin-right: 10px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 0px;
  .ant-collapse-content {
    background: rgba(13, 25, 68, 0.4);
    box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.11);
    max-height: 16rem;
    overflow-y: auto;
  }
  .ant-collapse-header {
    background: rgba(13, 25, 68, 0.6);
    box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.11);
    border-radius: 0px;
    color: #fff !important;
  }
  .ant-tree {
    color: #fff !important;
  }
  .ant-tree-node-content-wrapper {
    &:hover {
      background-color: rgba(0, 0, 0, 0.6) !important;
    }
    color: #fff !important;
  }
}
.dd-attr-table {
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 8px 16px;
    overflow-wrap: break-word;
    font-family: FZLanTingHei-DB-GBK;
    font-weight: 400;
    color: #fff;
  }
  .ant-table-row:hover {
    background-color: rgba(147, 147, 148, 0.9) !important;
  }
  .ant-table-header {
    background: rgba(13, 25, 68, 0.4);
    overflow-y: hidden !important;
    margin-bottom: 0px !important;
    overflow: hidden !important;
    th {
      background: none;
      font-weight: bold;
    }
  }
  .ant-table-body {
    background: rgba(13, 25, 68, 0.4) !important;
    overflow-y: auto !important;
    td {
      background: none !important;

      &:hover {
        background: none !important;
      }
    }
  }
}
.ant-tree-node-content-wrapper {
  height: auto !important;
  white-space: normal;
  width: calc(100% - 35px);
  width: -moz-calc(100% - 35px);
  width: -webkit-calc(100% - 35px);
}
.dd-right-menu-overlay {
  & > ul {
    background: rgba(13, 25, 68, 0.8);
    & > li {
      color: #fff !important;
    }
  }
}
.dd-search-overlay {
  right: 38px !important;
  left: auto !important;
  top: 214px !important;

  & > ul {
    background: rgba(13, 25, 68, 0.6);
    & > li {
      color: #fff !important;
    }
  }
}
.dd-analysis-overlay {
  right: 38px !important;
  left: auto !important;
  top: 250px !important;
  & > ul {
    background: rgba(13, 25, 68, 0.6);
    & > li {
      color: #fff !important;
    }
  }
}
.dd-tools-overlay {
  right: 38px !important;
  left: auto !important;
  top: 286px !important;
  & > ul {
    background: rgba(13, 25, 68, 0.6);
    & > li {
      color: #fff !important;
    }
  }
}
.ant-dropdown-menu-item-active {
  background-color: rgba(147, 147, 148, 0.9) !important;
}
</style>